import { Link } from "react-router-dom";

interface LogoProps {
  variant?: "dark" | "light";
  size?: "sm" | "md" | "lg";
  className?: string;
}

export default function Logo({ variant = "dark", size = "md", className = "" }: LogoProps) {
  const isDark = variant === "dark";
  const color = isDark ? "#1e2a5e" : "#ffffff";

  const sizes = {
    sm: { main: "text-lg", sub: "text-[8px]", icon: "w-6 h-6" },
    md: { main: "text-xl", sub: "text-[9px]", icon: "w-7 h-7" },
    lg: { main: "text-3xl md:text-4xl", sub: "text-[11px] md:text-xs", icon: "w-10 h-10" },
  };

  const s = sizes[size];

  return (
    <Link to="/" className={`flex items-center gap-2 no-underline ${className}`}>
      {/* Pool wave icon */}
      <span className={`${s.icon} flex items-center justify-center flex-shrink-0`}>
        <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          <circle cx="24" cy="24" r="22" stroke={color} strokeWidth="2.5" fill="none" />
          <path
            d="M12 28C16 24 20 32 24 28C28 24 32 32 36 28"
            stroke={color}
            strokeWidth="2.5"
            strokeLinecap="round"
            fill="none"
          />
          <path
            d="M14 22C18 18 22 26 26 22C30 18 34 26 38 22"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            fill="none"
            opacity="0.6"
          />
        </svg>
      </span>

      {/* Text */}
      <div className="flex flex-col leading-none">
        <span
          className={`${s.main} font-bold tracking-tight`}
          style={{ color, fontFamily: "'Oswald', sans-serif" }}
        >
          ATLAS
        </span>
        <span
          className={`${s.sub} font-semibold tracking-[0.2em] uppercase`}
          style={{ color, fontFamily: "'Oswald', sans-serif", marginTop: "1px" }}
        >
          Pro Services LLC
        </span>
      </div>
    </Link>
  );
}